<template>
	<AnalyticsSectionPreviewCard
		title="Top features"
		class="card-container"
		linkText="Show breakdown"
		:toRouteName="ANALYTICS_TOP_FEATURES_ROUTE_NAME"
	>
		<Col class="height-100 width-100">
			<AnalyticsTopFeatureItem
				class="feature-item"
				:numOfRuns="feature.runs"
				:flowData="feature.flow_data"
				v-for="feature in topFeaturesToDisplay"
				:key="`topFeaturesToDisplay${feature.flow_data?.id}`"
			/>
		</Col>
	</AnalyticsSectionPreviewCard>
</template>
<script>
import { ANALYTICS_TOP_FEATURES_ROUTE_NAME } from '@/router/router.const.js';
import AnalyticsMixin from '@/components/Analytics/mixins/AnalyticsMixin.js';
import AnalyticsTopFeatureItem from '@/components/Analytics/Cards/Items/AnalyticsTopFeatureItem.vue';
import AnalyticsSectionPreviewCard from '@/components/Analytics/Cards/AnalyticsSectionPreviewCard.vue';

export default {
	name: 'AnalyticsTopFeaturesCard',
	mixins: [AnalyticsMixin],
	components: { AnalyticsTopFeatureItem, AnalyticsSectionPreviewCard },
	computed: {
		topFeaturesToDisplay() {
			return this.runsByFeature.slice(0, this.maxNumberOfItemsInPreviewCard);
		},
	},
	data() {
		return { ANALYTICS_TOP_FEATURES_ROUTE_NAME };
	},
};
</script>
<style scoped lang="scss">
.card-container {
	max-height: 355px;
	min-height: 355px;
}
.feature-item {
	max-height: 47px;
	flex: 1;
}
</style>
